import styled from 'styled-components';
import { actionButton } from '../../styles/ActionButton.styled';

export const ImportButton = styled.label`
    ${actionButton}
`;

export const ImportInput = styled.input`
    display: none;
`;